import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  createUrlTreeFromSnapshot,
  RedirectCommand,
  Router,
} from '@angular/router';
import { ConfigService } from '../services/config.service';
import { FeatureFlagsResponse } from '../clients/portal/models';

export const featureFlagGuard =
  (flag: keyof FeatureFlagsResponse, redirectTo: string | false = '/'): CanActivateFn =>
  (route: ActivatedRouteSnapshot): boolean | RedirectCommand => {
    const configService = inject(ConfigService);
    if (configService.isEnabled(flag)) {
      return true;
    }
    if (redirectTo === false) {
      return false;
    }

    const router = inject(Router);
    const urlTree = route?.root
      ? createUrlTreeFromSnapshot(route, [redirectTo], route.queryParams)
      : router.parseUrl(redirectTo);

    return new RedirectCommand(urlTree);
  };
